import * as React from 'react';
import { ColumnLayout } from '@amzn/awsui-components-react/polaris';
import PropTypes from 'prop-types';
const keyValuePane = ({ width, columns }) => (React.createElement(ColumnLayout, { columns: width, variant: "text-grid" },
    React.createElement("div", { "data-awsui-column-layout-root": "true" }, columns.map((column, columnIndex) => (React.createElement("div", { key: columnIndex },
        React.createElement("div", { className: "awsui-util-spacing-v-s" }, column.map((item, itemIndex) => {
            return (item.value && (React.createElement("div", { key: itemIndex },
                React.createElement("div", { className: "awsui-util-label" }, item.key),
                React.createElement("div", null, item.value))));
        }))))))));
keyValuePane.displayName = 'KeyValuePane';
keyValuePane.propTypes = {
    width: PropTypes.number,
    columns: PropTypes.array,
};
export default keyValuePane;
//# sourceMappingURL=KeyValuePane.js.map